import React from 'react'
import { AnimatePresence } from 'framer-motion'

import { Toast } from './Toast'

import { Container } from './styles'

export function ToastContainer({ messages }) {
  return (
    <Container>
      <AnimatePresence>
        {messages.map((message) => (
          <Toast key={message.id} message={message} />
        ))}
      </AnimatePresence>
    </Container>
  )
}
